import React, { VFC } from 'react'
import useAnalysis from 'hooks/useAnalysis'
import { addClassName } from 'utils'

import Back from './Back'

type Props = {
  className?: string
}

const Pagination: VFC<Props> = (props) => {
  const { answerHistory } = useAnalysis()

  return (
    <nav className={addClassName(props.className)}>
      <ul className="flex justify-center space-x-6 sm:space-x-11">
        {answerHistory.length > 0 ? (
          <Back direction="prev" />
        ) : (
          <Back direction="top" />
        )}
        <Back direction="restart" doubleArrow />
      </ul>
    </nav>
  )
}

export default Pagination
